import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {ShowDialogsComponent} from 'src/app/components/show-dialogs/show-dialogs.component';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {SolutionsAppService} from 'src/app/services/solutions-app.service';
import {cloneDeep, isEqual} from 'lodash-es';
import {ProjectType, SolutionType, VersionType,} from 'src/app/types/sales-dna.types';
import {FormArray, FormBuilder, FormGroup, Validators,} from '@angular/forms';
import {JsonInputComponent} from 'src/app/components/json-input/json-input.component';
import {DataManagementAppService} from 'src/app/services/data-management-app.service';

@Component({
  selector: 'app-solution-configuration-form',
  templateUrl: './solution-configuration-form.component.html',
  styleUrls: ['./solution-configuration-form.component.scss'],
})
export class SolutionConfigurationFormComponent implements OnInit {
  activeSolution: SolutionType = {};
  activeVersion: VersionType = {version_id: ''};
  formLoading: boolean = true;
  schedule = ['once', 'manual', 'on_schedule'];
  scheduling_values: any = {};
  oldScheduling_values: any = {};
  title_values: any = {};
  oldTitle_values: any = {};
  usedDatasetsInVersion: any = undefined;
  availableValidationForDatasets: any;
  columnsToDisplay = ['source_id__connection_type_id', 'data_name', 'category'];
  usedNodesInVersion: any;
  modelVariableForStep2: any = {question: '', datasetname: '', column: ''};
  modelVariableStep3: any = {
    prompt: '',
    dataset: '',
    node: '',
    field: '',
    fieldType: '',
  };
  displayedColumnsStep2: string[] = ['Questions', 'Dataset', 'Column'];
  displayedColumns3: string[] = [
    'Prompt for User',
    'Select Dataset(s)',
    'Select Node',
    'Select Input Field(s)',
    'Input Field Type',
  ];
  jsonDataStep2 = [{...this.modelVariableForStep2}];
  jsonDataStep3 = [{...this.modelVariableStep3}];

  fieldDataType = [
    'text',
    'date',
    'single-select-string',
    'multi-select-string',
  ];

  /* section rail (left pane) */
  sections = [
    {id: 'cfg-s1', n: 1, title: 'Datasets', optional: false},
    {id: 'cfg-s2', n: 2, title: 'Column mappings', optional: false},
    {id: 'cfg-s3', n: 3, title: 'Run inputs', optional: false},
    {id: 'cfg-s4', n: 4, title: 'Schedule', optional: true},
    {id: 'cfg-s5', n: 5, title: 'Event triggers', optional: true},
  ];
  activeSection = 'cfg-s1';
  availableProjectInVersion: ProjectType[] = [];
  oldAvailableProjectInVersion: ProjectType[] = [];

  scheduleForm: FormGroup | any;
  eventTriggerForm: FormGroup | any;

  pipelinesMap: { [key: string]: any } = {};
  tagsMap: { [key: string]: any } = {};
  scheduledProjectSchedulerId: any = {};
  scheduledProjectsToDelete: any = [];
  eventTriggersToDelete: any = [];
  alreadyConfiguredProjectForScheduling: any;
  selectUnusedDataset: any = '';
  availableAllDataset: any;
  basicDatasetUsedInVersion: any;
  oldTriggerValues: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SolutionConfigurationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private detectChange: ChangeDetectorRef,
    private solutionServices: SolutionsAppService,
    private snackBar: SharedFeaturesService,
    private dialog: MatDialog,
    private sharedServices: SharedFeaturesService,
    private dataManagemnetService: DataManagementAppService,
    private fb: FormBuilder,
    private eventFb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
  }

  get schedules(): FormArray {
    return this.scheduleForm.get('schedules') as FormArray;
  }

  get eventTrigger(): FormArray {
    return this.eventTriggerForm.get('triggers') as FormArray;
  }

  ngOnInit() {
    this.scheduleForm = this.fb.group({
      schedules: this.fb.array([]),
    });
    this.eventTriggerForm = this.eventFb.group({
      triggers: this.eventFb.array([]),
    });
    this.activeSolution = this.data?.solution;
    this.activeVersion = this.data?.version;
    this.dataManagemnetService.getConfiguredDataSource().subscribe({
      next: (response: any) => {
        this.availableAllDataset = response;
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
    this.solutionServices
      .getProjectsInVersion(this.activeSolution, this.activeVersion)
      .subscribe({
        next: (response: any) => {
          if (response.length > 0) {
            for (let i = 0; i < response.length; i++) {
              response[i] = this.sharedServices.filterKeys(response[i], [
                'project_name',
                'project_id',
                'execution_order_id',
              ]);
            }
            this.getAvailableScheduler();
          } else {
            this.addSchedule();
          }
          this.availableProjectInVersion = response.sort(
            (a: any, b: any) => a.execution_order_id - b.execution_order_id
          );
          this.availableProjectInVersion.forEach((obj: any, index: number) => {
            obj.execution_order_id = index + 1;
            this.getPipelineOfProject(obj.project_id);
            this.getTagsOfProject(obj.project_id);
          });
          this.oldAvailableProjectInVersion = cloneDeep(
            this.availableProjectInVersion
          );
        },
      });
    this.solutionServices
      .getDatasetsUsedInVersion(this.activeVersion['version_id'])
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.basicDatasetUsedInVersion = [...response['msg']];
            this.usedDatasetsInVersion = response['msg'];
            this.usedDatasetsInVersion = this.mergeDatasets();
            this.sortUsedDataSet();
          } else this.usedDatasetsInVersion = undefined;
          this.formLoading = false;
        },
        error: (error) => {
          console.error('an error occurred', error);
          this.formLoading = false;
        },
      });
    this.solutionServices
      .getNodesUsedInVersion(this.activeVersion['version_id'])
      .subscribe({
        next: (response: any) => {
          this.usedNodesInVersion = response['msg'];
        },
      });
    if (this.data?.formData) {
      this.jsonDataStep2 = cloneDeep(
        this.data?.formData['config_json']['step2']
      );
      this.jsonDataStep3 = cloneDeep(
        this.data?.formData['config_json']['step3']
      );
      // saved forms store `false` for skipped steps — restore an editable row
      if (!Array.isArray(this.jsonDataStep2) || !this.jsonDataStep2.length) {
        this.jsonDataStep2 = [{...this.modelVariableForStep2}];
      }
      if (!Array.isArray(this.jsonDataStep3) || !this.jsonDataStep3.length) {
        this.jsonDataStep3 = [{...this.modelVariableStep3}];
      }
    }
    this.refreshDataValidation();
  }

  filterNodesByPipeline(pipelineId: string): any {
    const value = this.sharedServices.findObjectInArray(
      this.usedNodesInVersion,
      'pipeline_id',
      pipelineId
    );
    return Array.isArray(value) ? value : [value];
  }

  getPipelinesOrTags(etrigger: any): any[] {
    const value = etrigger.get('pipelines_or_tags')?.value;
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  compareNodesById(node1: any, node2: any): boolean {
    return node1 && node2 ? node1.node_id === node2.node_id : node1 === node2;
  }

  compareProjectById(project1: any, project2: any): boolean {
    return project1 && project2
      ? project1.project_id === project2.project_id
      : project1 === project2;
  }

  refreshDataValidation() {
    this.solutionServices
      .getDataValidationConfig(
        this.data?.solution?.solution_id,
        this.data?.version?.version_id
      )
      .subscribe({
        next: (response: any) => {
          this.availableValidationForDatasets = response?.msg;
        },
        error: (error: any) => {
          console.error('an error occurred', error);
        },
      });
  }

  comparePipelines(p1: any, p2: any): boolean {
    return p1 && p2 ? p1.pipeline_id === p2.pipeline_id : p1 === p2;
  }

  getPipelineOfProject(projectId: string): void {
    this.solutionServices
      .getConfiguredPipelines(
        this.activeSolution,
        this.activeVersion,
        projectId
      )
      .subscribe({
        next: (response: any) => {
          this.pipelinesMap[projectId] = response;
        },
        error: (error: any) => {
          console.error('An Error occurred', JSON.stringify(error));
          this.pipelinesMap[projectId] = [];
        },
      });
  }

  getTagsOfProject(projectId: string): void {
    this.solutionServices
      .getConfiguredTagsInProject(
        this.activeSolution,
        this.activeVersion,
        projectId
      )
      .subscribe({
        next: (response: any) => {
          this.tagsMap[projectId] = response;
        },
        error: (error: any) => {
          console.error('An Error occurred', JSON.stringify(error));
          this.tagsMap[projectId] = [];
        },
      });
  }

  add_new_question() {
    if (!Array.isArray(this.jsonDataStep2)) this.jsonDataStep2 = [];
    let temp = {...this.modelVariableForStep2};
    this.jsonDataStep2 = [...this.jsonDataStep2, temp]; // Update the dataSource with the new array
    this.detectChange.detectChanges();
  }

  add_new_algo() {
    if (!Array.isArray(this.jsonDataStep3)) this.jsonDataStep3 = [];
    const temp = {...this.modelVariableStep3};
    this.jsonDataStep3 = [...this.jsonDataStep3, temp]; // Update the dataSource with the new array
    this.detectChange.detectChanges();
  }

  removeField(data: any, index: number) {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Remove this field?',
        message: 'The field and its value will be removed from the form.',
        confirmText: 'Remove',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (data.length > 1) {
          data = data.splice(index, 1);
        } else {
          this.snackBar.openSnackBar(
            'Can not remove all data',
            'Close',
            'error-snackbar'
          );
        }
      }
    });
  }

  getColumnsForADataset(DataName: string): string[] {
    if (!DataName || !this.usedDatasetsInVersion) {
      return [];
    }

    const dataset = this.usedDatasetsInVersion.find(
      (item: any) => item.data_name === DataName
    );

    const columnsList = dataset?.columns || [];

    return columnsList.sort((a: string, b: string) => a.localeCompare(b));
  }

  getInputFieldsInNodes(node_id: string) {
    // Find the object with the matching 'node_id'
    if (!this.usedNodesInVersion) return [];
    const node = this.usedNodesInVersion.find(
      (item: any) => item.node_id === node_id
    );

    // If the node is found and it has an 'args' property
    if (node && node.node_config && node.node_config.args) {
      const args = node.node_config.args[0]; // Assuming there's only one item in 'args'

      // Exclude the specified keys from the 'args' object
      const excludedKeys = ['title', 'labels', 'data_types', 'repeatable'];
      const keys = Object.keys(args).filter(
        (key) => !excludedKeys.includes(key)
      );
      return keys;
    }

    return undefined; // Return undefined if 'node_id' not found or 'args' not present
  }

  resetForm() {
    const dialogRef = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Reset the form?',
        message: 'All fields will go back to their default values.',
        confirmText: 'Reset',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const step2 = {...this.modelVariableForStep2};
        const algo = {...this.modelVariableStep3};
        this.jsonDataStep2 = [step2];
        this.jsonDataStep3 = [algo];
        this.snackBar.openSnackBar(
          'Form has been reset',
          'Close',
          'success-snackbar'
        );
        this.detectChange.detectChanges();
      }
    });
  }

  closeDialogForm() {
    try {
      if (
        !isEqual(
          this.data?.formData['config_json']['step2'],
          this.jsonDataStep2
        ) ||
        !isEqual(
          this.data?.formData['config_json']['step3'],
          this.jsonDataStep3
        ) ||
        !isEqual(this.oldScheduling_values, this.scheduling_values) ||
        !isEqual(this.oldTitle_values, this.title_values) ||
        !isEqual(
          this.oldAvailableProjectInVersion,
          this.availableProjectInVersion
        )
      ) {
        const dialogRef = this.dialog.open(ShowDialogsComponent, {
          data: {
            title: 'Save your changes?',
            message: 'You have unsaved changes to this configuration.',
            confirmText: 'Save',
            cancelText: 'Discard',
          },
          disableClose: false,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            if (this.validateFormData()) {
              this.snackBar.openSnackBar(
                'invalid form data',
                'Close',
                'error-snackbar'
              );
              return;
            }
            this.save();
          }
          this.dialogRef.close();
        });
      } else {
        this.dialogRef.close();
      }
    } catch {
      this.dialogRef.close();
    }
  }

  getNodeName(nodeId: string) {
    if (!nodeId || !this.usedNodesInVersion) return '';
    const node = this.usedNodesInVersion.find(
      (item: any) => item.node_id === nodeId
    );
    return node?.node_name || '';
  }

  /* ---------- rail + live-preview helpers ---------- */

  sectionCount(id: string): number {
    switch (id) {
      case 'cfg-s1':
        return this.usedDatasetsInVersion?.length || 0;
      case 'cfg-s2':
        return this.step2Rows.length;
      case 'cfg-s3':
        return this.step3Rows.length;
      case 'cfg-s4':
        return this.schedules?.length || 0;
      case 'cfg-s5':
        return this.eventTrigger?.length || 0;
      default:
        return 0;
    }
  }

  scrollToSection(canvas: HTMLElement, id: string): void {
    this.activeSection = id;
    canvas
      .querySelector('#' + id)
      ?.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  onCanvasScroll(canvas: HTMLElement): void {
    const canvasTop = canvas.getBoundingClientRect().top;
    let active = this.sections[0].id;
    for (const s of this.sections) {
      const el = canvas.querySelector('#' + s.id);
      if (el && el.getBoundingClientRect().top - canvasTop < 90) {
        active = s.id;
      }
    }
    this.activeSection = active;
  }

  get step2Rows(): any[] {
    return Array.isArray(this.jsonDataStep2) ? this.jsonDataStep2 : [];
  }

  get step3Rows(): any[] {
    return Array.isArray(this.jsonDataStep3) ? this.jsonDataStep3 : [];
  }

  get scheduleQuestions(): string[] {
    return (
      this.schedules?.controls
        .map((c: any) => c.get('question')?.value)
        .filter(Boolean) || []
    );
  }

  fieldLabel(field: any): string {
    if (Array.isArray(field)) return field.join(', ') || '—';
    return field || '—';
  }

  validateFormData() {
    let flagStep2: boolean = false;
    let flagStep3: boolean = false;
    if (this.jsonDataStep2.length == 1) {
      if (this.jsonDataStep3.length == 1) {
        flagStep2 = this.snackBar.areAllValuesNonEmpty(this.jsonDataStep2[0]);
        flagStep3 = this.snackBar.areAllValuesNonEmpty(this.jsonDataStep3[0]);

        if (flagStep2) {
          flagStep3 =
            flagStep3 || this.snackBar.areAllValuesEmpty(this.jsonDataStep3[0]);
        } else if (flagStep3) {
          flagStep2 =
            flagStep2 || this.snackBar.areAllValuesEmpty(this.jsonDataStep2[0]);
        }
        return !(flagStep2 && flagStep3);
      } else if (this.jsonDataStep3.length > 1) {
        for (const item of this.jsonDataStep3) {
          let temp = this.snackBar.areAllValuesNonEmpty(item);
          if (!temp) return true;
        }
        flagStep3 = true;
        flagStep2 =
          this.snackBar.areAllValuesEmpty(this.jsonDataStep2) ||
          this.snackBar.areAllValuesNonEmpty(this.jsonDataStep2);
      } else return !this.snackBar.areAllValuesNonEmpty(this.jsonDataStep2[0]);
    } else if (this.jsonDataStep2.length > 1) {
      for (const item of this.jsonDataStep2) {
        let temp = this.snackBar.areAllValuesNonEmpty(item);
        if (!temp) return true;
      }
      flagStep2 = true;
      if (this.jsonDataStep3.length == 1) {
        flagStep3 =
          this.snackBar.areAllValuesEmpty(this.jsonDataStep3) ||
          this.snackBar.areAllValuesNonEmpty(this.jsonDataStep3);
      } else if (this.jsonDataStep3.length > 1) {
        for (const item of this.jsonDataStep3) {
          let temp = this.snackBar.areAllValuesNonEmpty(item);
          if (!temp) return true;
        }
        flagStep3 = true;
      }
    } else {
      if (this.jsonDataStep3.length == 1)
        return !this.snackBar.areAllValuesNonEmpty(this.jsonDataStep3[0]);
      else if (this.jsonDataStep3.length > 1) {
        for (const item of this.jsonDataStep3) {
          let temp = this.snackBar.areAllValuesNonEmpty(item);
          if (!temp) return true;
        }
        flagStep3 = true;
      }
    }

    return !(flagStep2 || flagStep3);
  }

  lengthCheckedEmptyData(data: any) {
    if (data.length === 1 && this.snackBar.areAllValuesEmpty(data[0])) {
      return false;
    }
    return data;
  }

  getAvailableScheduler() {
    this.solutionServices
      .getProjectScheduledInVersion(this.activeSolution, this.activeVersion)
      .subscribe({
        next: (response: any) => {
          this.alreadyConfiguredProjectForScheduling = response;
          this.patchScheduler();
        },
        error: (error: any) => {
          console.error('an error occurred', error);
        },
      });
  }

  patchScheduler(): void {
    if (this.alreadyConfiguredProjectForScheduling) {
      this.alreadyConfiguredProjectForScheduling.forEach((item: any) => {
        const scheduleGroup: any = this.fb.group({
          scheduler_id: [item?.scheduler_id ? item?.scheduler_id : ''],
          project: [
            this.sharedServices.findObjectInArray(
              this.availableProjectInVersion,
              'project_id',
              item.project_id
            ) || '',
            Validators.required,
          ],
          scheduleBy: [item.schedule_by_pipeline_or_tags, Validators.required],
          pipeline: [
            item.schedule_by_pipeline_or_tags === 'pipeline'
              ? item.pipelines_or_tags
              : '',
          ],
          tags: [
            item.schedule_by_pipeline_or_tags === 'tags'
              ? item.pipelines_or_tags
              : '',
          ],
          question: [item.question, Validators.required],
        });

        // Set validators based on scheduleBy value
        this.setValidatorsBasedOnScheduleBy('scheduleBy', scheduleGroup);

        // Subscribe to scheduleBy value changes
        scheduleGroup.get('scheduleBy').valueChanges.subscribe((value: any) => {
          this.onScheduleByChange(scheduleGroup, value, 'scheduleBy');
        });

        this.schedules.push(scheduleGroup);
      });
    }
  }

  setValidatorsBasedOnScheduleBy(
    control_name: string,
    group: FormGroup | any
  ): void {
    if (group.get(control_name).value === 'pipeline') {
      group.get('pipeline').setValidators(Validators.required);
      group.get('tags').clearValidators();
    } else if (group.get(control_name).value === 'tags') {
      group.get('tags').setValidators(Validators.required);
      group.get('pipeline').clearValidators();
    } else {
      group.get('pipeline').clearValidators();
      group.get('tags').clearValidators();
    }

    group.get('pipeline').updateValueAndValidity();
    group.get('tags').updateValueAndValidity();
  }

  setValidatorsBasedOnTriggers(
    control_name: string,
    group: FormGroup | any
  ): void {
    if (group.get(control_name).value === 'tags') {
      group.get('user_input_nodes').clearValidators();
    } else {
      group.get('user_input_nodes').setValidators(Validators.required);
    }
    group.get('user_input_nodes').updateValueAndValidity();
  }

  deleteScheduler() {
    if (this.scheduledProjectsToDelete.length > 0) {
      this.scheduledProjectsToDelete.forEach((item: any) => {
        this.solutionServices
          .deleteProjectScheduler(this.activeSolution, this.activeVersion, item)
          .subscribe();
      });
    }
  }

  cleanSchedules() {
    return (
      this.scheduleForm.value?.schedules?.map((schedule: any) => {
        const projectId = schedule.project.project_id || schedule.project;
        return {
          scheduler_id: schedule.scheduler_id,
          project_id: projectId,
          schedule_by_pipeline_or_tags: schedule.scheduleBy,
          question: schedule.question,
          pipelines_or_tags:
            schedule.scheduleBy === 'pipeline'
              ? schedule.pipeline
              : schedule.tags,
          is_active: true,
        };
      }) || []
    );
  }

  updateExistingScheduler(data: any) {
    this.solutionServices
      .updateProjectScheduler(
        this.activeSolution,
        this.activeVersion,
        data,
        data
      )
      .subscribe({
        next: (response: any) => {
          console.debug('project scheduled updated', JSON.stringify(response));
        },
        error: (error: any) => {
          this.sharedServices.openSnackBar(
            JSON.stringify(error),
            'Close',
            'error_snackbar'
          );
        },
      });
  }

  createScheduler(data: any) {
    this.solutionServices
      .saveProjectScheduler(this.activeSolution, this.activeVersion, data, data)
      .subscribe({
        next: (response: any) => {
          console.debug('project scheduled', JSON.stringify(response));
        },
        error: (error: any) => {
          this.sharedServices.openSnackBar(
            JSON.stringify(error),
            'Close',
            'error_snackbar'
          );
        },
      });
  }

  updateScheduler() {
    this.deleteScheduler();
    const cleanedSchedules = this.cleanSchedules();
    cleanedSchedules.forEach((item: any) => {
      if (item?.scheduler_id) {
        this.updateExistingScheduler(item);
      } else {
        this.createScheduler(item);
      }
    });
  }

  save() {
    this.saveUpdateTrigger();
    const saveJson = {
      version_id: this.activeVersion['version_id'],
      config_json: {
        step1: this.usedDatasetsInVersion,
        step2: this.lengthCheckedEmptyData(this.jsonDataStep2),
        step3: this.lengthCheckedEmptyData(this.jsonDataStep3),
      },
    };

    const projectOrder = {execution_order: this.availableProjectInVersion};

    if (this.validateFormData()) {
      this.snackBar.openSnackBar(
        'invalid form data',
        'Close',
        'error-snackbar'
      );
      return;
    } else {
      this.updateScheduler();
    }
    if (!this.data?.formData) {
      this.solutionServices
        .saveFrom(this.activeSolution, this.activeVersion, saveJson)
        .subscribe({
          next: (response: any) => {
            this.snackBar.openSnackBar(
              'Form created successfully',
              'Close',
              'success-snackbar'
            );
          },
          error: (error) => {
            console.error(
              'An error occurred while saving the form',
              JSON.stringify(error)
            );
            this.snackBar.openSnackBar(
              'An error occurred while saving the form',
              'Close',
              'error-snackbar'
            );
          },
        });
    } else {
      this.solutionServices
        .updateForm(
          this.activeSolution,
          this.activeVersion,
          this.data?.formData['form_id'],
          saveJson
        )
        .subscribe({
          next: (response: any) => {
            this.snackBar.openSnackBar(
              'Form updated successfully',
              'Close',
              'success-snackbar'
            );
          },
          error: (error) => {
            console.error(
              'An error occurred while updating the form',
              JSON.stringify(error)
            );
            this.snackBar.openSnackBar(
              'An error occurred while updating the form',
              'Close',
              'error-snackbar'
            );
          },
        });
    }
  }

  saveUpdateTrigger() {
    if (this.eventTriggerForm.invalid) {
      this.snackBar.openSnackBar(
        'Invalid data of Event Trigger',
        'Close',
        'error-snackbar'
      );
      return;
    }
    this.deleteEventTriggers();
    const values = this.eventTriggerForm.value?.triggers;
    if (!this.eventTriggerForm.invalid) {
      for (const item of values) {
        if (this.hasTriggerDataChanged(item)) {
          this.solutionServices
            .updateTriggers(
              this.activeSolution?.solution_id,
              this.activeVersion.version_id,
              item.dataset,
              item.trigger_id,
              item
            )
            .subscribe({
              next: (response: any) => {
                console.info('update successful', item);
              },
              error: (error: any) => {
                console.error('An error while updating trigger', item, error);
              },
            });
        } else if (item.trigger_id == '') {
          this.solutionServices
            .postTriggers(
              this.activeSolution?.solution_id,
              this.activeVersion.version_id,
              item.dataset,
              item
            )
            .subscribe({
              next: (response: any) => {
                console.info('save successful', item);
              },
              error: (error: any) => {
                console.error('An error while saving trigger', item, error);
              },
            });
        }
      }
    }
  }

  deleteEventTriggers() {
    for (const item of this.eventTriggersToDelete) {
      this.solutionServices
        .deleteTriggers(
          this.activeSolution.solution_id,
          this.activeVersion.version_id,
          item.dataset,
          item.trigger_id
        )
        .subscribe({
          next: (Response: any) => {
            console.info('deleted successfully', item.trigger_id);
          },
          error: (error: any) => {
            console.error(
              'An error occurred while deleting trigger',
              error,
              item.trigger_id
            );
          },
        });
    }
  }

  addSchedule(): void {
    this.schedules.push(
      this.fb.group({
        scheduler_id: [''],
        project: ['', Validators.required],
        scheduleBy: ['', Validators.required],
        pipeline: [''],
        tags: [''],
        question: ['', Validators.required],
      })
    );
  }

  removeSchedule(index: number): void {
    this.scheduledProjectsToDelete.push(this.schedules.at(index).value);
    this.schedules.removeAt(index);
  }

  addEventTriggers(): void {
    this.eventTrigger.push(
      this.eventFb.group({
        trigger_id: [''],
        project: ['', Validators.required],
        trigger_by_pipeline_or_tags: ['', Validators.required],
        pipelines_or_tags: [''],
        user_input_nodes: ['', Validators.required],
        dataset: ['', Validators.required],
        api_method: ['', Validators.required],
      })
    );
  }


  patchEventTriggers(): void {
    const triggersFormArray = this.eventTrigger;
    triggersFormArray.clear();

    for (const data of this.usedDatasetsInVersion) {
      this.solutionServices
        .getTriggersByVersion(
          this.activeSolution?.solution_id,
          this.activeVersion?.version_id,
          data.data_name
        )
        .subscribe({
          next: (response: any) => {
            response.forEach((value: any) => {
              const formGroup = this.eventFb.group({
                trigger_id: [value.trigger_id || ''],
                project: [value.project || '', Validators.required],
                trigger_by_pipeline_or_tags: [
                  value.trigger_by_pipeline_or_tags || '',
                  Validators.required,
                ],
                pipelines_or_tags: [value.pipelines_or_tags || ''],
                user_input_nodes: [value.user_input_nodes || ''],
                dataset: [value.dataset || '', Validators.required],
                api_method: [value.api_method || '', Validators.required],
              });

              formGroup
                .get('trigger_by_pipeline_or_tags')
                ?.valueChanges.subscribe((val) => {
                if (val === 'pipeline') {
                  formGroup
                    .get('user_input_nodes')
                    ?.setValidators([Validators.required]);
                } else {
                  formGroup.get('user_input_nodes')?.clearValidators();
                }
                formGroup.get('user_input_nodes')?.updateValueAndValidity();
              });
              triggersFormArray.push(formGroup);
              this.oldTriggerValues = triggersFormArray.controls.map(
                (control) => control.value
              );
            });
          },
        });
    }
  }

  hasTriggerDataChanged(item: any): boolean {
    const oldValue = this.oldTriggerValues.find(
      (oldVal) => oldVal.trigger_id === item.trigger_id
    );
    if (oldValue) {
      for (const key in item) {
        if (item.hasOwnProperty(key) && item[key] !== oldValue[key]) {
          return true;
        }
      }
    }

    return false;
  }

  removeTriggers(index: number): void {
    this.eventTriggersToDelete.push(this.eventTrigger.at(index).value);
    this.eventTrigger.removeAt(index);
  }

  sortUsedDataSet() {
    if (!Array.isArray(this.usedDatasetsInVersion)) return;
    this.usedDatasetsInVersion
      .sort((a: any, b: any) => a?.data_name.localeCompare(b?.data_name))
      .map((item: any) => {
        item.solution_id = this.activeSolution?.solution_id;
        item.version_id = this.activeVersion?.version_id;
        return item;
      });
    this.usedDatasetsInVersion = [...this.usedDatasetsInVersion];
    this.cdr.detectChanges();
    this.patchEventTriggers();
  }

  mergeDatasets() {
    const unionList = [
      ...this.usedDatasetsInVersion,
      ...(this.data?.formData?.config_json?.step1 || []),
    ]
      .reduce((acc, item) => {
        acc.set(item.data_name, item);
        return acc;
      }, new Map())
      .values();

    return Array.from(unionList);
  }

  convertData(sourceData: any): any {
    return {
      data_name: sourceData.data_name,
      destination_conf__table_name: sourceData?.destination_conf?.table_name,
      refresh_data_dtm: sourceData.refresh_data_dtm,
      category: sourceData.category,
      source_id__connection_type_id: sourceData.source__connection_type_id,
      columns: sourceData.extra_info?.mapping
        ? Object.values(sourceData.extra_info.mapping)
        : [],
    };
  }

  isDataSetAlreadyExist(dataSetName: string, dataList: any) {
    if (dataList) {
      return dataList.some((item: any) => item.data_name === dataSetName);
    }
  }

  addUnusedDatasets() {
    if (!Array.isArray(this.selectUnusedDataset) || !this.selectUnusedDataset.length) {
      this.snackBar.openSnackBar(
        'Select at least one dataset to add',
        'Close',
        'warning-snackbar'
      );
      return;
    }
    if (!Array.isArray(this.usedDatasetsInVersion)) {
      this.usedDatasetsInVersion = [];
    }
    this.selectUnusedDataset.forEach((item: any) => {
      const selectedDataset = this.snackBar.findObjectInArray(
        this.availableAllDataset,
        'id',
        item
      );
      if (selectedDataset) {
        this.usedDatasetsInVersion.push(this.convertData(selectedDataset));
      }
    });
    this.sortUsedDataSet();
    this.selectUnusedDataset = '';
  }

  removeAddedDataset(index: number) {
    if (index > -1 && index < this.usedDatasetsInVersion.length) {
      this.usedDatasetsInVersion.splice(index, 1);
      this.sortUsedDataSet();
    }
  }

  onScheduleByChange(
    group: FormGroup | any,
    value: string,
    control_name: string
  ): void {
    ['pipeline', 'tags', 'pipelines_or_tags'].forEach((control) => {
      if (group.get(control)) {
        group.get(control)?.setValue('');
      }
    });

    const validatorFunction =
      control_name === 'trigger_by_pipeline_or_tags'
        ? this.setValidatorsBasedOnTriggers
        : this.setValidatorsBasedOnScheduleBy;

    validatorFunction.call(this, control_name, group);
  }

  addDataSetValidationConfig(dataSetDetails: any) {
    const dialogRef = this.dialog.open(JsonInputComponent, {
      data: dataSetDetails,
      width: '680px',
      maxWidth: '94vw',
      panelClass: 'jv-dialog',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.refreshDataValidation();
    });
  }

  checkAddedValidation(dataName: string) {
    return this.sharedServices.findObjectInArray(
      this.availableValidationForDatasets,
      'dataset_name',
      dataName
    );
  }
}
